import storefront from "../storefront";
import { designers } from "../storefront/queries";
import unwrapNodes from "./unwrapNodes";

window.designersCache = window.designersCache || [];

export default function fetchDesigners() {
  const designersAfter = (cursor) => storefront.request({
    query: designers,
    variables: {
      after: cursor,
    },
  }).then(({ data }) => {
    window.designersCache.push(...unwrapNodes(data.metaobjects.edges).filter(designer => (designer.collection && designer.collection.products.length) || (designer.collection && designer.collection.metafield && designer.collection.metafield.value == "true")));

    if (data.metaobjects.pageInfo.hasNextPage) {
      return designersAfter(data.metaobjects.pageInfo.endCursor);
    }

    return window.designersCache;
  });

  if (!window.designersFirstRequest) {
    window.designersFirstRequest = designersAfter(null);
  }

  return window.designersFirstRequest;
};
